export default "__VITE_ASSET__BUuEGMhU__"